import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from "#app";
import { useAuth } from "../store/auth.store.js";
export default defineNuxtRouteMiddleware((to) => {
  const nuxtApp = useNuxtApp();
  const { $pinia } = nuxtApp;
  const authStore = useAuth($pinia);
  const allowList = ["/*/signout", "/profile/freelancer-signup/*", "/freelancer-signup/*", "/account/*", "/*/signin"];
  function isTryingToAccessOutsideProfileSignupCompletion(to2) {
    return !allowList.some((allowedPath) => new RegExp(allowedPath).test(to2.href));
  }
  if (authStore.loggedIn && authStore.isFreelancerApplicationInProgress && isTryingToAccessOutsideProfileSignupCompletion(to)) {
    return navigateTo("/profile/freelancer-signup/waiting-room/strategy", { external: true });
  }
});
